import React from 'react';
import { IfmsRoute }from '../../../config/types';


const MyTaskView = React.lazy(() => import('../MyTaskView'));

const routes:Array<IfmsRoute> = [
  {path: '/myTask', component: MyTaskView},
];

export default routes;